(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tb-ui-react/inline-message/assets/inline-error-message.js') >= 0) return;  svs.modules.push('/components/tb-ui-react/inline-message/assets/inline-error-message.js');
'use strict';

const InlineMessage = svs.components.tb_ui_react.inlineMessage.InlineMessage;

const InlineErrorMessage = _ref => {
  let actions = _ref.actions,
    header = _ref.header,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    children = _ref.children,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '900' : _ref$size,
    _ref$buttonOptions = _ref.buttonOptions,
    buttonOptions = _ref$buttonOptions === void 0 ? {
      inverted: true
    } : _ref$buttonOptions;
  return React.createElement(InlineMessage, {
    actions: actions,
    buttonOptions: buttonOptions,
    className: className,
    header: header,
    icon: "exclamation-sign",
    isError: true,
    size: size
  }, children);
};
svs.components.tb_ui_react.inlineMessage.InlineErrorMessage = InlineErrorMessage;

 })(window);